const angular = require('angular');
const app = angular.module('learn-directives');

/**
 * Defines the add question component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('addQuestion', ['Application', 'Authorization', function (Application, Authorization) {
  return {
    restrict: 'E',
    scope: {
      question: '=',
      instructions: '='
    },
    template: require('../../../templates/directives/cms/add-question.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      self.getError = Application.notifications.getError;
      self.getSuccess = Application.notifications.getSuccess;
      self.currentUser = Authorization.getAuthToken().user;
      var letters = 'abcdefghijklmnopqrstuvwxyz';
      
      self.removeAnswer = function(answer, indexRemove) {
        var firstAnswer;
        var original = letters.indexOf(answer.letter);
        var reassign = answer.correct;
        $scope.question.answers.splice(indexRemove, 1);

        angular.forEach($scope.question.answers, function(answer) {
          var index = letters.indexOf(answer.letter);
          if (index > original) {
            answer.letter = letters[index - 1];
          }
          if (answer.letter === 'a' && reassign) {
            answer.correct = true;
          }
        });
      };

      self.addAnswer = function() {
        if ($scope.question.answers.length >= letters.length) {
          return;
        }

        $scope.question.answers.push({
          answer: '',
          correct: false,
          letter: letters[$scope.question.answers.length]
        });
      };

      self.changeAnswer = function(letter) {
        angular.forEach($scope.question.answers, function(answer) {
          if (answer.letter === letter) {
            answer.correct = true;
            return;
          }
          answer.correct = false;
        });
      };

      self.setInstructions = function(item) {
        $scope.instructions = item;
      };

    }],
    controllerAs: 'addQuestion'
  };
}]);
